import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import * as Log from "~/app/core/log";

@Component({
    selector: "accountContactSponsor",
    templateUrl: "./accountContactSponsor.component.html",
    styleUrls: ["./accountContactSponsor.component.scss"]
})
export class AccountContactSponsorComponent implements OnInit {
  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
  }
}
